import { render, staticRenderFns } from "./AchievementCategoryCreate.vue?vue&type=template&id=2defd659"
import script from "./AchievementCategoryCreate.vue?vue&type=script&lang=js"
export * from "./AchievementCategoryCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports